(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/libs/highcharts/assets/javascripts/modules/no-data-to-display.src.js') >= 0) return;  svs.modules.push('/components/libs/highcharts/assets/javascripts/modules/no-data-to-display.src.js');
(function (factory) {
    if (typeof module === 'object' && module.exports) {
        factory['default'] = factory;
        module.exports = factory;
    } else if (typeof define === 'function' && define.amd) {
        define('highcharts/modules/no-data-to-display', ['highcharts'], function (Highcharts) {
            factory(Highcharts);
            factory.Highcharts = Highcharts;
            return factory;
        });
    } else {
        factory(typeof Highcharts !== 'undefined' ? Highcharts : undefined);
    }
}(function (Highcharts) {
    'use strict';
    var _modules = Highcharts ? Highcharts._modules : {};
    function _registerModule(obj, path, args, fn) {
        if (!obj.hasOwnProperty(path)) {
            obj[path] = fn.apply(null, args);

            if (typeof CustomEvent === 'function') {
                Highcharts.win.dispatchEvent(new CustomEvent(
                    'HighchartsModuleLoaded',
                    { detail: { path: path, module: obj[path] } }
                ));
            }
        }
    }
    _registerModule(_modules, 'Extensions/NoDataToDisplay/NoDataDefaults.js', [], function () {
        const lang = {
            noData: 'No data to display'
        };
        const noData = {
            attr: {
                zIndex: 1
            },
            position: {
                x: 0,
                y: 0,
                align: 'center',
                verticalAlign: 'middle'
            },
            style: {
                fontWeight: 'bold',
                fontSize: '0.8em',
                color: "#666666" 
            }
        };
        const NoDataDefaults = {
            lang,
            noData
        };

        return NoDataDefaults;
    });
    _registerModule(_modules, 'Extensions/NoDataToDisplay/NoDataToDisplay.js', [_modules['Core/Renderer/HTML/AST.js'], _modules['Extensions/NoDataToDisplay/NoDataDefaults.js'], _modules['Core/Utilities.js']], function (AST, NoDataDefaults, U) {
        const { addEvent, extend, merge } = U;
        function chartHasData() {
            const chart = this, series = chart.series || [];
            let i = series.length;
            while (i--) {
                if (series[i].hasData() && !series[i].options.isInternal) {
                    return true;
                }
            }
            return chart.loadingShown; 
        }
        function chartHideNoData() {
            const chart = this;
            if (chart.noDataLabel) {
                chart.noDataLabel = chart.noDataLabel.destroy();
            }
        }
        function chartShowNoData(str) {
            const chart = this, options = chart.options, text = str || (options && options.lang.noData) || '', noDataOptions = options && (options.noData || {});
            if (chart.renderer) { 
                if (!chart.noDataLabel) {
                    chart.noDataLabel = chart.renderer
                        .label(text, 0, 0, void 0, void 0, void 0, noDataOptions.useHTML, void 0, 'no-data')
                        .add();
                }
                if (!chart.styledMode) {
                    chart.noDataLabel
                        .attr(AST.filterUserAttributes(noDataOptions.attr || {}))
                        .css(noDataOptions.style || {});
                }
                chart.noDataLabel.align(extend(chart.noDataLabel.getBBox(), noDataOptions.position || {}), false, 'plotBox');
            }
        }
        function compose(ChartClass, highchartsDefaultOptions) {
            const chartProto = ChartClass.prototype;
            if (!chartProto.showNoData) {
                chartProto.hasData = chartHasData;
                chartProto.hideNoData = chartHideNoData;
                chartProto.showNoData = chartShowNoData;
                addEvent(ChartClass, 'render', onChartRender);
                merge(true, highchartsDefaultOptions, NoDataDefaults);
            }
        }
        function onChartRender() {
            const chart = this;
            if (chart.hasData()) {
                chart.hideNoData();
            }
            else {
                chart.showNoData();
            }
        }
        const NoDataToDisplay = {
            compose
        };

        return NoDataToDisplay;
    });
    _registerModule(_modules, 'masters/modules/no-data-to-display.src.js', [_modules['Core/Globals.js'], _modules['Extensions/NoDataToDisplay/NoDataToDisplay.js']], function (Highcharts, NoDataToDisplay) {

        const G = Highcharts;
        NoDataToDisplay.compose(G.Chart, G.defaultOptions);

        return Highcharts;
    });
}));


 })(window);